"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OperationId = void 0;
var _mui = require("@ori-ui/mui");
var _getOperationTrackingLink = require("./getOperationTrackingLink");
var _jsxRuntime = require("react/jsx-runtime");
const OperationId = ({
  operationId,
  operationResourceId,
  disable
}) => {
  if (disable) {
    return null;
  }
  let content = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: ["Operation ID: ", operationId ?? 'n/a']
  });
  if (operationResourceId && operationId !== undefined) {
    content = /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
      target: "_blank",
      rel: "noreferrer",
      href: (0, _getOperationTrackingLink.getOperationTrackingLink)({
        operationId,
        operationResourceId
      }),
      children: content
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    id: "operation-id",
    children: content
  });
};
exports.OperationId = OperationId;
